import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import { IDeleteServiceTypeArgs } from "./deleteServiceType.schema";

export const deleteServiceType = (axios: IAxiosInstance) => {
  return async (params: IDeleteServiceTypeArgs) => {
    try {
      const { companyID, serviceTypeID } = params;
      await axios.noRetry.delete(`/service-types`, {
        params: { companyID, serviceTypeID },
      });
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
